import SessionEventProto from "../session-event-proto";


export default class SessionEvent_CompaniesReset extends SessionEventProto {


    constructor(sessionEvent:any) {
        super(sessionEvent)
    }


    process() {

        //const raw = this.data.slice(0);

        gd.session.companies.resetFromJson(this.data);
        gd.session.companies.sort();

        // My work views are per company, they can only be created once companies are known
        gd.user?.settings?.views?.myWork?.syncCompanies();


        // Patch - it's needed
        if (!gd.company && gd.companyId) {
            gd.company = gd.session.companies.get(gd.companyId)
        }
        //

        // gd.session.recent.organizations.reInit(); old - remove

        // not here
        // gd.initCurOrganizationId();

        //gd.tree related
        const treeCompanies : any[] = [];
        this.data && this.data.map((company:JSONObject)=>{
            treeCompanies.push({
                accountType: company.accountType,
                icon: company.icon,
                id: company.id,
                isAdmin: company.isAdmin,
                name: company.name,
                role: company.role
                //finance? do we need it here ?
            });
        });

        gd.tree.reset(treeCompanies);

        gd.bus.triggerEvent("companies-reset");

        let liveSupportEnabled = true;
        this.data && this.data.map((company:any)=>{
            if (!company.liveSupport) {
                liveSupportEnabled = false
            }
        });

        // @ts-ignore
        if (gd.liveSupport) {
            // @ts-ignore
            gd.liveSupport.setIsEnabledForCurrentUser(liveSupportEnabled);
        }

    }
};
